import ReportCabinetModal from './ReportCabinetModal'
export default ReportCabinetModal